import { render, staticRenderFns } from "./GenericReport.vue?vue&type=template&id=f4a5dbf0&scoped=true&"
import script from "./GenericReport.vue?vue&type=script&lang=js&"
export * from "./GenericReport.vue?vue&type=script&lang=js&"
import style0 from "./GenericReport.vue?vue&type=style&index=0&id=f4a5dbf0&lang=scss&scoped=true&"
import style1 from "./GenericReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a5dbf0",
  null
  
)

export default component.exports